// src/terminal/commands/index.js

import { registerFilesystemCommands } from './filesystem';
import { registerAuthCommands } from './auth';
import { registerNavigationCommands } from './navigation';
import { registerSystemCommands } from './system';
import { registerEasterEggs } from './easterEggs';
import { registerArgCommands } from './arg';

export { handleLoginPassword } from './auth';

export function buildCommandMap({ fsState, addLines, navigate, unlock, setTerminalState, trackEvent }) {
  const map = {};

  registerFilesystemCommands(map, fsState, addLines);
  registerAuthCommands(map, fsState, addLines, setTerminalState);
  registerNavigationCommands(map, addLines, navigate);
  registerSystemCommands(map, fsState, addLines, trackEvent);
  registerArgCommands(map, addLines, navigate, unlock, trackEvent, fsState);  // ← ADD fsState
  registerEasterEggs(map, addLines, trackEvent);

  return map;
}